import React, { useContext, useEffect } from "react";

import ShareButtons from "../../common/ShareButtons.js";
import { IImagePreview, Image } from "../../../graphql/queries/gallery.js";
import MediaItem from "../../gallery/_common/MediaItem.js";
import { EngagementInfo } from "../../../graphql/queries/_common.js";
import { App } from "../../../graphql/queries/app-config.js";
import AppBanners from "../../common/banners/AppBanners.js";
import { gaTrackOutcomeQuizEvent } from "../../../helpers/googleAnalytics.js";
import AppBannersContainer from "../../common/banners/AppBannersContainer.js";

// import {
//     mediaItemContainer,
//     navButton,
//     pageTitle,
//     quizText,
//     topicTags,
// } from "../common/styles/common.css.js";
import MarkdownRenderer from "../../common/MarkdownRenderer.js";
import { Topic } from "../../../graphql/queries/topics.js";
import TopicTags from "../../common/TopicTags.js";
import { Content } from "../../layout/CommonContentContextProvider.js";
import { restartButton } from "../quiz/Summary.css.js";
import {
    mediaItemContainer,
    navButton,
    pageTitle,
    quizText,
    topicTags,
} from "../quiz/common.css.js";

interface Props {
    quizId: string;
    slug: string | null;
    res: string;
    title: string;
    text: string;
    mediaItem?: Image | IImagePreview | null;
    apps: App[];
    restartButtonText: string;
    shareMessage: string;
    shareBlockTitle?: string;
    onRestartHandler: () => void;
    pagePath: string;
    engagementInfo: EngagementInfo;
    topics: (Topic | null)[];
}

const OutcomeQuizSummary: React.FC<Props> = ({
    quizId,
    slug,
    res,
    title,
    text,
    apps,
    mediaItem,
    pagePath,
    restartButtonText,
    shareMessage,
    shareBlockTitle,
    onRestartHandler,
    engagementInfo,
    topics,
}) => {
    const { langCode } = useContext(Content);
    useEffect(() => {
        gaTrackOutcomeQuizEvent("ShowResult", quizId, langCode, res);
    }, [quizId, res]);

    return (
        <>
            <h1 className={pageTitle}>{title}</h1>
            <MarkdownRenderer className={quizText} source={text} />

            <TopicTags
                topics={topics}
                place="quiz_summary"
                cpath={pagePath}
                className={topicTags}
            />
            <ShareButtons
                pageTitle={shareMessage}
                position="quiz-result"
                typename="OutcomeQuiz"
                pagePath={pagePath}
                engagementInfo={engagementInfo}
                medium={quizId}
                label={`${quizId}_${res}`}
                title={shareBlockTitle}
                slug={slug}
            />
            <div className={mediaItemContainer}>
                <MediaItem
                    mediaItem={mediaItem || null}
                    showPlaceholder={false}
                    srcSetSizes={{
                        tablet: 614,
                    }}
                />
                <button
                    className={`${restartButton} ${navButton} restart-quiz-button`}
                    onClick={onRestartHandler}
                >
                    {restartButtonText}
                </button>
            </div>
            <AppBannersContainer>
                <AppBanners
                    promoApps={apps}
                    location="quiz-result"
                    item={quizId}
                />
            </AppBannersContainer>
        </>
    );
};

export default OutcomeQuizSummary;
